/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {ReactComponent as Search} from "../assets/img/icons/search-box.svg";
import {useTranslation} from "react-i18next";

const PageHeader = (props) => {

    const { t, i18n } = useTranslation();

    function onChangeHandle(e){
        props.onSearch(e.target.value);
        if ( props.onUpdateSearch ){
            props.onUpdateSearch( e.target.value!== '' );
        }
    }

    return (
        <>
            <div className='page-header__row'>
                <div className='page-header__content'>

                    <div className='page-header__content-row'>
                        { props.data.logo && <div className='page-header__icon'><img src={props.data.logo} alt='car' /> </div> }
                        <div className='page-header__title'>{props.data.title}</div>
                    </div>
                    { props.data.description && <div className='page-header__description'>{props.data.description}</div>}

                </div>
                <div className='page-header__aside'>
                    <div className='search-box search-box--small'>
                        <div className='search-box__row'>
                            <div className='search-box__icon'>
                                <Search/>
                            </div>
                            <div className='search-box__element'>
                                <input className='form-control' placeholder={ t('parts.quickSearch' ) } onChange={ onChangeHandle } value={props.value}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PageHeader;
